<template>
  <div
    class="page"
    :style="{ height: pageHeight }"
  >
    <!-- nav -->
    <div class="nav">
      <div class="nav-title">
        关于
      </div>
    </div>
    <!-- 动画 -->
    <via-lottie
      :animation-data="animationData"
      :height="200"
      :width="375"
      :animation-speed="0.8"
      class="lottie"
    />

    <!-- 手风琴 -->
    <van-collapse
      v-model="activeName"
      accordion
    >
      <van-collapse-item
        v-for="(item, index) in infoList"
        :id="item.title == '致谢' ? 'thanks-collapse' : ''"
        :key="index"
        :border="false"
        :title="item.title"
        :name="index"
        :value="item.subtitle"
      >
        <van-icon
          slot="icon"
          class="collapse-left-icon"
          class-prefix="icon"
          :size="$vw('20px')"
          :name="item.icon"
        />
        {{ item.content }}
        <!-- 致谢单 -->
        <van-index-bar
          v-if="item.title == '致谢'"
          id="about-index-bar"
          highlight-color="#fb7299"
          :index-list="thanks.indexList"
        >
          <div
            v-for="thankItem in thanks.items"
            :key="thankItem.title"
          >
            <van-index-anchor
              class="index-anchor"
              :index="thankItem.index"
            >{{ thankItem.title }}</van-index-anchor>
            <van-cell
              v-for="person in thankItem.persons"
              :key="person.name"
              :title="person.name"
              @click="linkTo(person.link)"
            />
          </div>
        </van-index-bar>
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
import ViaLottie from 'components/common/via-lottie'
import * as animationData from 'static/lottie/lottie-think.json'
import { Collapse, CollapseItem, IndexBar, IndexAnchor, Cell } from 'vant'

export default {
  name: 'About',
  components: {
    [ViaLottie.name]: ViaLottie,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [IndexBar.name]: IndexBar,
    [IndexAnchor.name]: IndexAnchor,
    [Cell.name]: Cell
  },
  data() {
    return {
      animationData: animationData.default,
      activeName: null,
      infoList: [
        {
          icon: 'androidsend',
          title: '插件、主页投稿',
          subtitle: '',
          content: '如果你是开发者，想投稿插件或主页，可以通过以下方式联系我：酷安@谷花泰、QQ：2214962083（备注投稿）'
        },
        {
          icon: 'iconfontweixin',
          title: '公众号',
          subtitle: '',
          content: '微信搜索公众号 via轻插件'
        },
        {
          icon: 'iosbook',
          title: '更新日志',
          subtitle: '',
          content: '2018年3月第一版，2019年9月第二版，开发者后台开发中，后续上线。'
        },
        {
          icon: 'socialgithub',
          title: '致谢',
          subtitle: '排名不分先后',
          content: ''
        }
      ],
      thanks: {
        indexList: ['开发', '设计', '赞助', '宣传'],
        items: [
          {
            title: '开发组',
            index: '开发',
            persons: [
              {
                name: '赵日天',
                link: 'https://baidu.com'
              },
              {
                name: '叶良辰',
                link: 'https://sina.cn'
              },
              {
                name: '乔碧萝',
                link: 'https://qq.com'
              },
              {
                name: '篮球大使',
                link: ''
              }
            ]
          },
          {
            title: '设计组',
            index: '设计',
            persons: [
              {
                name: '赵日天',
                link: 'https://baidu.com'
              },
              {
                name: '叶良辰',
                link: 'https://sina.cn'
              },
              {
                name: '乔碧萝',
                link: 'https://qq.com'
              },
              {
                name: '篮球大使',
                link: ''
              }
            ]
          },
          {
            title: '赞助组',
            index: '赞助',
            persons: [
              {
                name: '赵日天',
                link: 'https://baidu.com'
              },
              {
                name: '叶良辰',
                link: 'https://sina.cn'
              },
              {
                name: '乔碧萝',
                link: 'https://qq.com'
              },
              {
                name: '篮球大使',
                link: ''
              }
            ]
          },
          {
            title: '宣传组',
            index: '宣传',
            persons: [
              {
                name: '赵日天',
                link: 'https://baidu.com'
              },
              {
                name: '叶良辰',
                link: 'https://sina.cn'
              },
              {
                name: '乔碧萝',
                link: 'https://qq.com'
              },
              {
                name: '篮球大使',
                link: ''
              }
            ]
          }
        ]
      }
    }
  },
  computed: {
    pageHeight() {
      const tabbarHeight = this.$rpxToPx(60)
      return this.$pxToVw(this.$clientHeight - tabbarHeight) + 'vw'
    }
  },
  watch: {
    // 首页数据
    // '$store.state.home.result'(newValue, oldValue) {
    //   this.updateData(newValue)
    // }
  },
  activated() {
    const aboutConfig = this.$api.home.getAbout()
    this.updateData(aboutConfig)
  },
  methods: {
    updateData(aboutConfig) {
      if (!aboutConfig) {
        return
      }
      const { infoList, thanks } = aboutConfig
      this.infoList = infoList
      this.thanks = thanks
    },
    linkTo(url) {
      if (!url) {
        this.$toast.fail('点人家干嘛，讨厌')
        return
      }
      window.open(url, '_blank')
    }
  }
}
</script>

<style scoped>
.page {
    width: 375px;
    overflow-x: hidden;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
}
/* nav */
.nav {
    width: 375px;
    height: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    overflow: hidden;
}
.nav-title {
    font-size: 30px;
    font-weight: 900;
    margin-left: 15px;
}

.lottie {
    margin: 15px 0;
}
.collapse-left-icon {
    margin-right: 8px;
}
.index-anchor {
    background-color: var(--light90);
}
</style>
<style>
#thanks-collapse .van-collapse-item__content {
    padding: 0;
}
#about-index-bar .van-index-bar__index {
    line-height: 30px;
}
</style>
